(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var mq = window.matchMedia('(max-width: 989px)');

  // Galerie: Punkte unter dem Wischbild
  var media = root.querySelector('.product__media');
  var imgs = media ? media.querySelectorAll('.product__img') : [];
  if (media && imgs.length > 1) {
    var dots = document.createElement('div');
    dots.className = 'pdots';
    for (var i = 0; i < imgs.length; i++) dots.appendChild(document.createElement('i'));
    media.parentNode.insertBefore(dots, media.nextSibling);
    var setDot = function () {
      var idx = Math.round(media.scrollLeft / Math.max(media.clientWidth, 1));
      dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('is-on', n === idx); });
    };
    media.addEventListener('scroll', function () { window.requestAnimationFrame(setDot); }, { passive: true });
    setDot();
  }

  // Feste Warenkorb-Leiste am Handy, sobald der Hauptbutton aus dem Bild ist
  var addBtn = root.querySelector('[data-add]');
  var priceEl = root.querySelector('[data-price]');
  var titleEl = root.querySelector('.product__title');
  if (!addBtn) return;
  var bar = document.createElement('div');
  bar.className = 'psticky';
  bar.innerHTML = '<div class="psticky__info"><span class="psticky__title"></span><span class="psticky__price"></span></div><button type="button" class="btn"></button>';
  document.body.appendChild(bar);
  var bTitle = bar.querySelector('.psticky__title');
  var bPrice = bar.querySelector('.psticky__price');
  var bBtn = bar.querySelector('.btn');
  var sync = function () {
    bTitle.textContent = titleEl ? titleEl.textContent.split(' – ')[0] : '';
    var strong = priceEl ? priceEl.querySelector('strong') : null;
    bPrice.textContent = strong ? strong.textContent : '';
    bBtn.textContent = addBtn.textContent.trim();
    bBtn.disabled = addBtn.disabled;
  };
  sync();
  new MutationObserver(sync).observe(addBtn, { childList: true, characterData: true, subtree: true, attributes: true });
  if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
  bBtn.addEventListener('click', function () { addBtn.click(); });

  var visible = true;
  var update = function () {
    var on = mq.matches && !visible && addBtn.getBoundingClientRect().top < 0 || (mq.matches && !visible && window.scrollY > 300);
    bar.classList.toggle('is-on', !!on);
    document.body.classList.toggle('has-psticky', !!on);
  };
  new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(addBtn);
  mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update);
  window.addEventListener('scroll', update, { passive: true });
})();